import { createApi } from '@reduxjs/toolkit/query/react';

import { URL } from 'api';
import { addParamsToUrl } from 'utils';
import { CourseStep, PaginationResponse } from 'types';

import { apiQuery } from '../../query';

import {
  ListRequest,
  ListResponse,
  DetailsRequest,
  CourseStepResponse,
} from './types';

const tagTypes = ['COURSE_STEPS'];

export const courseStepsApi = createApi({
  tagTypes,
  baseQuery: apiQuery,
  reducerPath: 'courseStepsApi',
  endpoints: (build) => ({
    details: build.query<CourseStep, DetailsRequest>({
      providesTags: tagTypes,
      transformResponse: (response: CourseStepResponse) => response.data,
      query: ({ id }) => ({
        method: 'get',
        url: URL.COURSE_STEP_DETAILS.replace(':id', id),
      }),
    }),

    list: build.query<PaginationResponse<CourseStep>, ListRequest>({
      providesTags: tagTypes,
      transformResponse: (response: ListResponse) => response.data,
      query: (params) => ({
        method: 'get',
        url: addParamsToUrl(URL.COURSE_STEPS_LIST, params),
      }),
    }),
  }),
});

export const { useListQuery, useDetailsQuery } = courseStepsApi;

export type { ListRequest };
